
import { Options, Vue } from 'vue-class-component'

import SvgIcon from './SvgIcon.vue'
import { engines } from '@/utils/search'

@Options({
  components: {
    SvgIcon
  },
  props: [
    'currentEngineIndex'
  ]
})
export default class EngineBox extends Vue {
  currentEngineIndex!: number

  get allEngines () {
    return engines
  }
}
